import { ContentPasteOutlined } from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { NavbarItem } from '@collaborate-health/uikit'
import { useSelector } from '@tabeeb/store'
import { getIsFormsFeatureEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { useFormTitleFormatter } from '@tabeeb/modules/shared/utils/text'

const FormsTab: React.FC = () => {
  const { f } = useFormTitleFormatter()

  const display = useSelector(getIsFormsFeatureEnabled)
  if (!display) {
    return null
  }

  return <NavbarItem name={f('Forms')} href={Routes.forms} icon={<ContentPasteOutlined />} />
}

export default FormsTab

